import { BaseService } from "core/services";
import { FacilityOrderTemplateMissingDocumentRouteService } from "application/facility-order/services";

class FacilityOrderTemplateMissingDocumentService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderTemplateMissingDocumentRouteService());
	}

}

export default FacilityOrderTemplateMissingDocumentService;